// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__footer__3gaM7","name":"footer__name__WNDVM"};